// extracted by mini-css-extract-plugin
export default {"container":"style_container__2ATBq","name":"style_name__cxuX9","continfo":"style_continfo__Blt9b","badge":"style_badge__gX7xm"};